// extracted by mini-css-extract-plugin
module.exports = {"tools-card-layout":"toolCard_tools-card-layout__SjKo1"};